import {RepositoryFileList as RepositoryFileList_} from './RepositoryFileList';
import {templateImporter} from './import'

export const RepositoryFileList = RepositoryFileList_
export const importer = templateImporter



// WEBPACK FOOTER //
// ./src/knowledge2/knowledge2.ts